<template>
    <b-card>
        <div v-if="$store.state.isTablet" >
            <b-row style="font-weight: bold; text-align: start; margin-bottom:10px">
                <span style="text-align: center;">
                      {{$t('title')}}
                </span>
            </b-row>
            <b-row align-v="end">
                <site-type-select v-if="siteTypes.length" style="margin-right: 20px" @onchange="onSiteTypeChange"/>
                <b-col>
                    <region-multi-select
                    :selectedRegionId="selectedRegionId"
                    :regions="regions"
                    @oninput="($event)=>{selectedRegionId = ($event) ? ($event).id : null;getData(selectedRegionId,selectedTypeId)}"
                />
                </b-col>
                <b-col>
                    <site-multi-select
                        :selectedSiteId="selectedSiteId"
                        :givenSites="filteredSitesForSelect"
                        :allowEmpty="true"
                        @oninput="selectSiteId"/>
                </b-col>
            </b-row>
        </div>   
            <div v-else >
                <b-row align-h="between" class="mt-2 mb-4">
                    <b-col style="font-weight: bold; text-align: start;">
                        <span style="text-align: center;">
                            {{$t('title')}}
                        </span>
                    </b-col>
                    <b-form-checkbox
                        style="user-select: none;"
                        v-model="twoYearBool"
                        :value="true"
                        :unchecked-value="false">
                        <b>{{ $t('twoYearFilter').line1 }}</b>
                        <br/>
                        <b>{{ $t('twoYearFilter').line2 }}</b>
                    </b-form-checkbox>
                    <b-col cols="9" sm="9" md="7" lg="5" xl="6">
                        <b-row align-h="end" no-gutters>
                            <site-type-select v-if="siteTypes.length" style="margin-right: 20px" @onchange="onSiteTypeChange"/>
                            <region-multi-select
                                style="margin-right:10px"
                                :selectedRegionId="selectedRegionId"
                                :regions="regions"
                                @oninput="($event)=>{selectedRegionId = ($event) ? ($event).id : null;getData(selectedRegionId,selectedTypeId)}"
                            />
                            <site-multi-select
                                :selectedSiteId="selectedSiteId"
                                :givenSites="filteredSitesForSelect"
                                :allowEmpty="true"
                                @oninput="selectSiteId"/>
                        </b-row>
                    </b-col>
                </b-row>
            </div>
        <div class="table-responsive scroll-content mt-3" style="margin-top: 15px;">
            <table class="table table-hover" style="table-layout: fixed; font-size: 0.875em;border-collapse: separate;border-spacing:0;">
                <thead style="position: sticky;background-color: white;top: 0px;z-index:2">
                    <tr v-if="this.$store.state.user.permissions.canCreateAudit" @click="insertRow($event.target,'create')" class="insert-row">
                        <td :colspan="5">
                            <div class="tableBodyCell">
                                <div style="position: absolute; left: 0; top:auto; right: 0; margin:auto; z-index:100px;">
                                    <i class="fas fa-plus-circle fa-2x"></i>
                                </div>
                            </div>
                        </td>
                    </tr>
                <tr>
                    <th style="width: 10em;">{{ $t('branch')  }}</th>
                    <th style="width: 10em;">{{ $t(this.getGroupName('agent')) }}</th>
                    <th style="width: 10em;">{{ $t('Outer Audit')  }}</th>
                    <th style="width: 10em;">{{ $t('Inner Audit')  }}</th>
                    <th style="width: 10em;">{{ $t('Control')  }}</th>
                </tr>
                </thead>
                <tbody>
                    <tr v-for="(audit,index) in twoYearBool?withTwoYearFilter:filteredSites" :key="index">
                        <td style="color: #007bff;cursor: pointer;" @click="routeToDocumentDetail(audit.id)">{{audit.name}}</td>
                        <td>
                            <div v-if="audit.agents">
                                <span v-for="(agent,index) in audit.agents" :key="index">
                                    <router-link :to="{name: 'user-profile', params: {user_id: audit.agentIds[index]}}">{{ agent ? agent : '-' }} </router-link>
                                </span>
                            </div>
                            <div v-else>
                                -
                            </div>
                        </td>
                        <td v-if="Audits[audit.id]?Audits[audit.id]['last_external_audit_date']:null">{{Audits[audit.id]['last_external_audit_date'] | formatDate('YYYY-MM-DD') }}</td>
                        <td v-else>-</td>
                        <td v-if="Audits[audit.id]?Audits[audit.id]['last_internal_audit_date']:null">{{Audits[audit.id]['last_internal_audit_date'] | formatDate('YYYY-MM-DD') }}</td>
                        <td v-else>-</td>
                        <td v-if="Audits[audit.id]?Audits[audit.id]['last_control_audit_date']:null">{{Audits[audit.id]['last_control_audit_date'] | formatDate('YYYY-MM-DD') }}</td>
                        <td v-else>-</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </b-card>
</template>

<script>
import _ from 'lodash';
import SiteTypeSelect from '../../../components/SiteTypeSelect';
import RegionMultiSelect from '../../../components/RegionMultiSelect';
import SiteMultiSelect from '../../../components/SiteMultiSelect';
import uuid from 'uuid/v4';

export default {
    name: 'Audit',
    components: {RegionMultiSelect, SiteTypeSelect, SiteMultiSelect},
    data() {
        return {
            regions: [],
            selectedRegionId: null,
            selectedTypeId: null,
            selectedSiteId: null,
            Audits: [],
            filteredSitesForSelect: _.filter(this.$store.state.sites, {isOpen: 1}),
            filteredSites: _.filter(this.$store.state.sites, {isOpen: 1}),
            twoYearBool: false,
            openSites: _.filter(this.$store.state.sites, {isOpen: 1})
        };
    },
    methods: {
        selectSiteId(site) {
            this.$store.state.siteId = site ? site.id : null;
            if (site) {
                this.selectedSiteId = site.id;
                this.filteredSites = _.filter(this.$store.state.sites, {
                    id: this.selectedSiteId,
                    isOpen: 1
                });
            } else {
                this.selectedSiteId = null;
                this.filteredSites = this.openSites;
            }
        },
        getSiteName(siteId) {
            let found = _.find(this.openSites, {id: siteId});
            if (found) {
                return found.name;
            }
            return null;
        },
        getData(selectedRegionId, selectedTypeId) {
            this.axios
                .get(`/audits/records/?region_id=${selectedRegionId}&type_id=${selectedTypeId}`)
                .then(({data}) => {
                    this.Audits = data;
                    let filteredByType =
                        selectedTypeId !== null
                            ? _.filter(this.filteredSites, {typeId: selectedTypeId, isOpen: 1})
                            : this.openSites;
                    let filteredByRegion =
                        selectedRegionId !== null
                            ? _.filter(filteredByType, {siteGroupId: selectedRegionId, isOpen: 1})
                            : filteredByType;
                    this.filteredSites =
                        this.selectedSiteId !== null
                            ? _.filter(filteredByType, {
                                  siteGroupId: this.selectedSiteId,
                                  isOpen: 1
                              })
                            : filteredByRegion;
                });
        },
        // Insert a new table row
        insertRow(target, editType) {
            this.$store.commit('SET_MODAL', {
                eventId: uuid(),
                type: 'createAudit',
                payload: {
                    editType: editType,
                    reloadFunction: this.getData,
                    selectedRegionId: this.selectedRegionId,
                    selectedTypeId: this.selectedTypeId
                }
            });
            this.$nextTick(() => {
                this.$root.$emit('bv::show::modal', 'createAudit', target);
            });
        },
        onSiteTypeChange(siteTypeId) {
            this.selectedRegionId = null;
            this.selectedTypeId = siteTypeId;
            this.getData(this.selectedRegionId, siteTypeId);
        },
        routeToDocumentDetail(site_id) {
            this.$store.state.siteId = site_id;
            let routeData = this.$router.resolve({
                name: 'Detail',
                params: {site_id: site_id},
                query: {year: this.year}
            });
            if (this.gbId(this.$store.state.user.customerId)) {
                window.open(routeData.href, '_blank');
            } else {
                this.$router.push({
                    name: 'Detail',
                    params: {site_id: site_id},
                    query: {year: this.year}
                });
            }
            return Promise.resolve();
        },
        configureAudit() {
            this.tempAudits = _.map(this.audits, audit => {
                let foundItem = _.find(this.sites, {id: audit.siteId});
                if (foundItem) {
                    return {
                        openedCount: audit.openedAuditCount,
                        totalCount: audit.totalAuditCount,
                        siteId: audit.siteId,
                        code: foundItem.code,
                        siteGroupId: foundItem.siteGroupId,
                        name: foundItem.name,
                        updatedAt: audit.updatedAt
                    };
                } else {
                    return audit;
                }
            });
            return Promise.resolve(true);
        }
    },
    computed: {
        withTwoYearFilter() {
            if (this.twoYearBool) {
                return _.filter(this.filteredSites, site => {
                    if (this.Audits[site.id]) {
                        let internalAuditDate = new Date(
                            this.Audits[site.id]['last_internal_audit_date']
                        ).getFullYear();
                        if (
                            internalAuditDate === null ||
                            internalAuditDate < new Date().getFullYear() - 2
                        ) {
                            return site;
                        }
                    } else {
                        return site;
                    }
                });
            }
        }
    },
    created() {
        this.getData(this.selectedRegionId, this.selectedTypeId);
        this.regions = [{id: null, display_name: this.$t('allRegions')}, ...this.siteGroups];
        this.$Progress.start();
    }
};
</script>
<style scoped>
.insert-row:hover {
    background-color: #ececec;
}
</style>

<i18n src="../../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "title": "DENETİM",
            "openedCount": "Açık Madde",
            "totalCount": "Toplam Madde",
            "lastUpdatingTime": "Son Güncelleme Tarihi",
            "twoYearFilter": {
                "line1":"Son 2 yılda iç denetim",
                "line2":"yapılmamış şubeler"
                }
        },
        "en": {
            "title": "AUDITS",
            "openedCount": "Open Items",
            "totalCount": "Total Items",
            "lastUpdatingTime": "Last Update",
            "twoYearFilter": {
                "line1":"Sites don't have internal",
                "line2":"audits for two years"
            }
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Audit/AuditRecords/Summary.vue